import dayjs from "dayjs";
import type { FC } from "react";

import { InputDatePickerStyle } from "../../../../documentation/styles/InputStyle";
import type { AntCustomFormField, DatePickerAttributes } from "../../types/types";

interface DatePickerProps extends AntCustomFormField<string>, DatePickerAttributes {
    name: string;
    readOnly: boolean;
    placeholder?: string;
}

export const DatePickerInput: FC<DatePickerProps> = ({
    name,
    placeholder,
    value,
    onChange,
    type,
    format = "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    readOnly,
    ...restProps
}) => {
    const handleChange = (date: unknown, _dateString: string | string[] | null) => {
        if (onChange) {
            const newValue = dayjs.isDayjs(date) ? date.format(format) : "";
            onChange(newValue);
        }
    };

    // Parse incoming value to match the format
    const currentValue = value ? dayjs(value, "YYYY-MM-DD") : undefined;

    return (
        <InputDatePickerStyle
            name={name}
            placeholder={placeholder}
            value={currentValue}
            picker={type}
            defaultValue={currentValue}
            onChange={handleChange}
            disabled={readOnly}
            size="large"
            {...restProps}
        />
    );
};
